module.exports = __webpack_public_path__ + "static/media/star-02.ca4a022f.svg";